export const LAYOUT_CONTENT_PADDING = 16 as const;
